/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bench_DescInputs */

const en_fw_bench_desc = /** @type {(inputs: Fw_Bench_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep publishes an anonymous Agent Pass Rate from verification evidence — no task text, no repository, no name, and never a group smaller than 5 tasks.`)
};

const id_fw_bench_desc = /** @type {(inputs: Fw_Bench_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep menerbitkan Agent Pass Rate anonim dari bukti verifikasi — tanpa teks task, tanpa repositori, tanpa nama, dan tidak pernah untuk kelompok di bawah 5 task.`)
};

/**
* | output |
* | --- |
* | "Bystep publishes an anonymous Agent Pass Rate from verification evidence — no task text, no repository, no name, and never a group smaller than 5 tasks." |
*
* @param {Fw_Bench_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bench_desc = /** @type {((inputs?: Fw_Bench_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bench_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bench_desc(inputs)
	return en_fw_bench_desc(inputs)
});